angular.module("ainapp")
    .controller("resaveVouchersController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Resave Vouchers";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.load = 0;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.VoucherList = [];
                MainService.GetResaveVoucherList().then(function (response) {
                    if (response.data) {
                        $scope.VoucherList = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = 0;
                    $.LoadingOverlay("hide");

                });

            }
            $scope.Init();


            $scope.resaveData = {};
            $scope.resaveVoucher = function (data) {
                $scope.resaveData = data;
                $("#ResaveModal").modal("show");
            }

            $scope.saveVouchersConfirm = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                if ($scope.resaveData.VoucherName == "Material Request") {
                    MainService.ResaveAllMaterialRequest().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });
                }
                else if ($scope.resaveData.VoucherName == "Purchase Request") {
                    MainService.ResaveAllPurchaseRequest().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });
                } else if ($scope.resaveData.VoucherName == "Purchase Enquiry") {
                    MainService.ResaveAllPurchaseEnquiry().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });
                } else if ($scope.resaveData.VoucherName == "Purchase Quotation") {
                    MainService.ResaveAllPurchaseQuotation().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Purchase Order") {

                    MainService.ResaveAllPurchaseOrder().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });


                } else if ($scope.resaveData.VoucherName == "Goods Received") {

                    MainService.ResaveAllGoodsReceived().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Purchase Invoice") {
                    MainService.ResaveAllPurchaseInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Direct Purchase Invoice") {
                    MainService.ResaveAllDirectPurchaseInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Individual Purchase Invoice") {
                    MainService.ResaveAllIndividualPurchaseInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Import Purchase Invoice") {
                    MainService.ResaveAllImportPurchaseInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Export Purchase Invoice") {
                    MainService.ResaveAllExportPurchaseInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Purchase Return") {
                    MainService.ResaveAllPurchaseReturn().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Sales Enquiry") {
                    MainService.ResaveAllSalesEnquiry().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Sales Quotation") {
                    MainService.ResaveAllSalesQuotation().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Packing List") {
                    MainService.ResaveAllPackingList().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Sales Order") {
                    MainService.ResaveAllSalesOrder().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Delivery Note") {
                    MainService.ResaveAllDeliveryNote().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Sales Invoice") {
                    MainService.ResaveAllSalesInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Direct Sales Invoice") {
                    MainService.ResaveAllDirectSalesInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Individual Sales Invoice") {
                    MainService.ResaveAllIndividualSalesInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Export Sales Invoice") {
                    MainService.ResaveAllExportSalesInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Porfoma Invoice") {
                    MainService.ResaveAllPorfomaInvoice().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Sales Return") {
                    MainService.ResaveAllSalesReturn().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Company Expense") {
                    MainService.ResaveAllCompanyExpense().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Journal Voucher") {
                    MainService.ResaveAllJournalVoucher().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Opening Balance") {
                    MainService.ResaveAllOpeningBalance().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Credit Note") {
                    MainService.ResaveAllCreditNote().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Debit Note") {
                    MainService.ResaveAllDebitNote().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Cash Payment") {
                    MainService.ResaveAllCashPayment().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Cash Receipt") {
                    MainService.ResaveAllCashReceipt().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Fund Payment") {
                    MainService.ResaveAllFundPayment().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Fund Receipt") {
                    MainService.ResaveAllFundReceipt().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Cheque Payment") {
                    MainService.ResaveAllChequePayment().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Cheque Receipt") {
                    MainService.ResaveAllChequeReceipt().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Opening Stock") {
                    MainService.ResaveAllOpeningStock().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Stock Receive") {
                    MainService.ResaveAllStockReceive().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Stock Issue") {
                    MainService.ResaveAllStockIssue().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Stock FOC") {
                    MainService.ResaveAllStockFOC().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else if ($scope.resaveData.VoucherName == "Stock JV") {
                    MainService.ResaveAllStockJV().then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $("#ResaveModal").modal("hide");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = 0;
                        $.LoadingOverlay("hide");

                    });

                } else {
                    $.LoadingOverlay("hide");
                }


            }




        }])
